import { useRef, useState } from 'react';
import { Button, Modal } from '@safetyhub/ui';
import { ModalCancelButton } from '../ModalCancelButton';

interface SaveWithReasonModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
  isLoading?: boolean;
}

export default function SaveWithReasonModal({
  isOpen,
  onClose,
  onConfirm,
  isLoading,
}: SaveWithReasonModalProps) {
  const [reason, setReason] = useState('');
  // 첫 포커스는 사유 입력 — `autoFocus`는 base가 열림 직후 패널로 포커스를 옮기며 덮으므로
  // `initialFocusRef`로 준다(종전 admin 자체 base도 같은 이유로 그 autoFocus를 덮고 있었다).
  const reasonRef = useRef<HTMLTextAreaElement>(null);

  const handleConfirm = () => {
    if (!reason.trim()) return;
    onConfirm(reason.trim());
  };

  const handleClose = () => {
    setReason('');
    onClose();
  };

  // 저장 중에는 닫는 길(오버레이·Esc·✕) 전부를 막는다.
  const locked = !!isLoading;

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      title="변경 사유 입력"
      size="sm"
      initialFocusRef={reasonRef}
      closeOnOverlay={!locked}
      closeOnEsc={!locked}
      showCloseButton={!locked}
      closeLocked={locked}
      // 미저장 닫기 보호 — 닫으면 사유를 비우므로(handleClose) 기준선은 빈 칸이다.
      isDirty={reason !== ''}
    >
      <div className="space-y-4">
        {/* 부제 — base `Modal`에 부제 칸이 없어 본문 머리에 둔다(종전 `description`). */}
        <p className="text-sm text-gray-500">결재라인 메타 변경 시 사유를 반드시 입력해야 합니다.</p>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            변경 사유 <span className="text-red-500">*</span>
          </label>
          <textarea
            ref={reasonRef}
            className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-500 resize-none"
            rows={3}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="변경 이유를 입력하세요 (예: 조직 구조 변경, 결재 프로세스 개선)"
          />
        </div>
        <div className="flex justify-end gap-2">
          <ModalCancelButton onCancel={handleClose} disabled={locked} />
          <Button variant="primary" onClick={handleConfirm} disabled={!reason.trim() || isLoading}>
            {isLoading ? '저장 중...' : '저장'}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
